import { Button, Link, Loader } from 'arag-ui-lib'
import { amountColumnsDisplayDataPerStage } from '../../helpers/functions'
import StagedStep4 from './WizardSteps/stagedStep4'

const ApplicationStagedPremiumSettings = (props) => {
  const {
    applicationPolicy,
    stagedPremiumSettingsWizard,
    appStagedSubSettings,
    stagedPremiums,
    onEditStaged,
    isChangingStatusOfApp,
    onCancel,
    goingLiveLoading,
    handleSubmit,
  } = props

  return (
    <div>
      <h3>Application Premium Settings</h3>
      {(applicationPolicy.premiumSettingsIndicator ||
        stagedPremiumSettingsWizard.patching ||
        goingLiveLoading) && <Loader />}

      {!(
        applicationPolicy.premiumSettingsIndicator &&
        stagedPremiumSettingsWizard.patching &&
        goingLiveLoading
      ) && (
        <div>
          <StagedStep4
            amountColumnsDisplayDataPerStage={amountColumnsDisplayDataPerStage}
            isApplicationPremium={true}
            stagesSubSettings={appStagedSubSettings}
            stagedPremiumData={stagedPremiums.stagedPremiumSetting}
          />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            {isChangingStatusOfApp && (
              <div style={{ maxHeight: 34, paddingRight: 10 }}>
                <Button
                  variant='primary'
                  label={'Save and go live'}
                  arrowDirection='right'
                  disabled={
                    applicationPolicy.premiumSettingsIndicator ||
                    stagedPremiumSettingsWizard.patching ||
                    goingLiveLoading
                  }
                  onClick={handleSubmit}
                />
              </div>
            )}

            <Button
              variant='quaternary'
              label='Edit'
              arrowDirection='right'
              disabled={
                applicationPolicy.premiumSettingsIndicator ||
                stagedPremiumSettingsWizard.patching ||
                goingLiveLoading
              }
              onClick={onEditStaged}
            />

            {(applicationPolicy.premiumSettingsIndicator ||
              stagedPremiumSettingsWizard.patching ||
              goingLiveLoading) && <Loader />}
            {isChangingStatusOfApp && (
              <div style={{ maxHeight: 34, paddingTop: 10 }}>
                <Link
                  variant='tertiary'
                  label={'Cancel'}
                  arrowDirection='left'
                  disabled={
                    applicationPolicy.premiumSettingsIndicator ||
                    stagedPremiumSettingsWizard.patching ||
                    goingLiveLoading
                  }
                  onClick={onCancel}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
export default ApplicationStagedPremiumSettings
